import React from "react";
import "./styles.css";
import TramyCard from "../UI/tramy-card";
import { usageArray } from "../../constants/contents";

function Usage() {
  return (
    <div className="usage">
      <h1>Así funciona Tramy.io en tu negocio</h1>
      <div className="usage__cards">
        {usageArray.map((usage) => (
          <TramyCard
            icon={usage.icon}
            title={usage.title}
            description={usage.description}
          />
        ))}
      </div>
    </div>
  );
}

export default Usage;
